import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class CustomNotificationService {
    private threadRecipientsUpdated = new Subject<any>();
    threadRecipientsUpdated$ = this.threadRecipientsUpdated.asObservable();

    private unreadMessageCount: BehaviorSubject<number> =
        new BehaviorSubject<number>(0);
    unreadMessageCount$ = this.unreadMessageCount.asObservable();

    constructor() {}

    onthreadRecipientsUpdated(message) {
        this.threadRecipientsUpdated.next(message);
    }

    updateUnreadMessageCount(count: number): void {
        this.unreadMessageCount.next(count)
    }
}
